/**
 *
 * CustomTime
 *
 */

import React, { memo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// antd component
import { Form } from "antd";
import { TimePicker } from "../../../CustomAntdPickers/CustomAntdPickers";

// icons
//import CustomIcons from 'components/CustomIcons';

function CustomTime({
  format,
  label,
  name,
  placeholder,
  required,
  loading,
  disabled,
  initialValue,
  // actions
  onChange,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames("tcf-time-wrapper", className);
  const { t } = useTranslation();

  const defaultLabel = typeof label === "string" ? t(label) : label;
  const defaultPlaceholder = typeof placeholder === "string" ? t(placeholder) : placeholder;

  return (
    <Form.Item
      className={childClassNames}
      key={`${name}-date-select`}
      label={defaultLabel}
      name={name}
      initialValue={initialValue}
      loading={!!loading}
      rules={[
        {
          required: required,
          message: t("inputs.selectRequiredField"),
        },
      ]}
      {...rest}
    >
      <TimePicker
        placeholder={defaultPlaceholder}
        onChange={onChange}
        format={format}
        disabled={!!disabled}
      />
    </Form.Item>
  );
}

CustomTime.defaultProps = {
  required: true,
  disabled: false,
  loading: false,
  label: "absences.hours",
  placeholder: "absences.selectHours",
  format: "HH:mm",
};
CustomTime.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  format: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
};

export default memo(CustomTime);
